module.exports = __webpack_public_path__ + "img/service_thing.f3d9f685.png";